// Coffee program data shared by the /coffee page and its JSON-LD so the
// visible content and the structured data never drift apart.
//
// Lots rotate. When Local Coffee Roasters changes an origin, update this file
// and the matching bean entries in lib/data/toast-menu.ts together, and keep
// prices matched to the roastery's own 12 oz website pricing (agreed with ops).
//
// Swapping a bag photo: give the new file a NEW name rather than overwriting.
// vercel.json serves /images/* as `max-age=31536000, immutable`, so a reused
// filename keeps serving the old shot from browser cache for up to a year.

export const COFFEE_ROASTER = {
  name: "Local Coffee Roasters",
  url: "https://localcoffeeroasters.co",
  city: "Chino Hills",
  region: "CA",
} as const

export type CoffeeLot = {
  id: string
  /** Item name in lib/data/toast-menu.ts ("Coffee Beans by Local Coffee Roasters" group) */
  menuName: string
  displayName: string
  origin: string
  producer: string
  altitude: string
  process: string
  tastingNotes: string
  /** One-line role of this coffee at the café, shown on the lot card */
  role: string
  /** 12 oz whole-bean retail price (USD), matched to the roastery's website */
  price: number
  /** Square studio bag shot, served from /public. Also used in the Product JSON-LD. */
  image: string
  imageAlt: string
}

export const COFFEE_LOTS: CoffeeLot[] = [
  {
    id: "brazil",
    menuName: "Brazil",
    displayName: "Brazil — Minas Gerais Luzia",
    origin: "Minas Gerais, Brazil",
    producer: "Cocatrel cooperative, near Três Pontas",
    altitude: "950–1,120 m",
    process: "Natural",
    tastingNotes:
      "Caramel, chocolate, and cream with a soft, nutty finish and mild citric acidity",
    role: "Our espresso — the shot in every latte on the menu",
    price: 26,
    image: "/images/plusbake/coffee/brazil-minas-gerais-luzia.webp",
    imageAlt:
      "12 oz bag of Local Coffee Roasters Brazil Minas Gerais Luzia whole bean coffee",
  },
  {
    id: "ethiopia",
    menuName: "Ethiopia",
    displayName: "Ethiopia — Yirgacheffe Aricha",
    origin: "Aricha, Yirgacheffe, Ethiopia",
    producer: "Adorsi washing station, 800+ smallholder farms",
    altitude: "1,900–2,150 m",
    process: "Washed",
    tastingNotes: "Floral and bright — fresh matcha, caramel, and juicy mango",
    role: "Our brightest cup — take it home for pour-over",
    price: 27,
    image: "/images/plusbake/coffee/ethiopia-yirgacheffe-adorsi.webp",
    imageAlt:
      "12 oz bag of Local Coffee Roasters Ethiopia Yirgacheffe whole bean coffee",
  },
  {
    id: "colombia",
    menuName: "Colombia",
    displayName: "Colombia — Sugarcane Decaf",
    origin: "Colombia",
    producer: "Sugarcane (ethyl acetate) decaffeination",
    altitude: "High-grown",
    process: "Sugarcane decaf",
    tastingNotes: "Sweet and smooth — decaf that keeps its natural sweetness",
    role: "Proof that decaf drinkers get serious coffee too",
    price: 30,
    image: "/images/plusbake/coffee/colombia-sugarcane-decaf.webp",
    imageAlt:
      "12 oz bag of Local Coffee Roasters Colombia sugarcane decaf whole bean coffee",
  },
]
